import { reactErrorHandler } from '@sentry/react';

const handleError = reactErrorHandler((error, info) => {
  console.error(error, info.componentStack);
});

export default handleError;
